// extracted by mini-css-extract-plugin
module.exports = {"block":"HeaderSearch_block__a1KxA","search":"HeaderSearch_search__7pXTh"};